import "@gaiaProfessionals/Store/MeetYourHerbs/GAIAMeetYourHerbsReducer";
import "@gaiaProfessionals/Store/ProductList/GAIAProductListReducer";
import { addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { ButtonWrapper } from "@insite/mobius/Button/Button";
import { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { RadioStyle } from "@insite/mobius/Radio";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { css } from "styled-components";
// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
// const pages = require.context("./Pages", true, /\.tsx$/);
// const onHotPageReplace = addPagesFromContext(pages);
// if (module.hot) {
//     module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
// }

// const store = require.context("./Store", true);
// store.keys().forEach(key => store(key));
// if (module.hot) {
//     module.hot.accept(store.id, () => onHotWidgetReplace(require.context("./Store", true)));
// }

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

// add some post styleguide customizations. These cannot be overridden by the style guid.
setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 992, 1200],
        maxWidths: [576, 576, 768, 992, 1440],
    },
    typography: {
        fontFamilyImportUrl: "/staticContent/stylesheet.css",
        body: {
            fontFamily: "Lato",
            size: "15px",
        },
        p: {
            fontFamily: "Lato",
            size: "1rem",
        },
        headerPrimary: {
            fontFamily: "LibreBaskervilleBold",
            size: "1.5rem",
        },
        headerSecondary: {
            fontFamily: "LibreBaskervilleBold",
            size: "15px",
        },
        headerTertiary: {
            fontFamily: "Lato",
            size: "15px",
        },
        h1: {
            fontFamily: "LibreBaskervilleBold",
            size: "2.25rem",
        },
        h2: {
            fontFamily: "LibreBaskervilleBold",
            size: "1.5rem",
        },
        h3: {
            fontFamily: "LibreBaskervilleBold",
            size: "1rem",
        },
        h4: {
            fontFamily: "LibreBaskervilleBold",
            size: "15px",
        },
        h5: {
            fontFamily: "LibreBaskervilleBold",
            size: "14px",
        },
        h6: {
            fontFamily: "LibreBaskervilleBold",
            size: "13px",
        },
    },
    formField: {
        defaultProps: {
            cssOverrides: {
                formInputWrapper: css`
                    margin-top: 5px !important;
                `,
                inputSelect: css`
                    border: 1px solid #828282;
                    border-radius: 4px;
                    &:focus {
                        outline-color: #09f;
                        outline-style: solid;
                        outline-width: 2px;
                        border-radius: 4px;
                    }
                    :-moz-placeholder {
                        color: #767676;
                        opacity: 1;
                    }

                    ::-moz-placeholder {
                        color: #767676;
                        opacity: 1;
                    }
                `,
            },
            labelProps: {
                color: "#1A1A1A",
                fontFamily: "LatoBold",
                size: "15px",
                transform: "capitalize",
            },
        },
    },
    accordion: {
        sectionDefaultProps: {
            headerProps: {
                css: css`
                    button {
                        border-radius: 4px;
                        background: #f0f4f3;
                        border: none;
                        margin-bottom: 8px;
                        > ${TypographyStyle} {
                            font-size: 20px;
                            /* padding: 0 1rem; */
                            font-family: "LibreBaskerville";
                            font-weight: normal;
                        }
                        &:focus {
                            border: 1px solid #09f;
                            outline-color: #09f;
                            outline-style: solid;
                            outline-width: 2px;
                        }
                    }
                    button[aria-expanded="true"] {
                        outline-color: #09f;
                        outline-style: solid;
                        outline-width: 2px;
                    }
                `,
            },
            panelProps: {
                css: css`
                    padding: 0.7rem 1.6rem;
                    border: none;
                    > ${GridWrapper} {
                        > ${GridOffset} {
                            > ${GridItemStyle} {
                                ${RadioStyle} {
                                    ${TypographyStyle} {
                                        font-size: 14px;
                                    }
                                }
                            }
                            > ${GridItemStyle}:last-child {
                                > ${TypographyStyle} {
                                    font-size: 1rem;
                                }
                            }
                        }
                    }
                `,
            },
            titleTypographyProps: {
                css: css`
                    color: ${getColor("primary")};
                `,
            },
            toggleIconProps: {
                css: css`
                    color: ${getColor("primary")};
                `,
            },
        },
    },
    dataTable: {
        defaultProps: {
            cssOverrides: {
                head: css`
                    th {
                        background-color: #f0f4f3;
                        border-right: 1px solid #e5e5e5;
                        border-bottom: none;
                        border-radius: 4px;
                        button {
                            height: 90%;
                        }
                    }
                    th:last-child {
                        border-right: none;
                    }
                `,
                body: css`
                    tr:nth-child(even) {
                        background: #ffffff;
                    }
                `,
                cell: css`
                    height: 60px;
                `,
            },
            headerTypographyProps: {
                color: "primary",
            },
        },
    },
    tag: {
        defaultProps: {
            css: css`
                background-color: #f3efeb;
                border-radius: 4px;
                color: ${getColor("primary")};
                ${TypographyStyle} {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
                > ${ButtonWrapper} {
                    background-color: transparent;
                }
            `,
        },
    },
    pagination: {
        defaultProps: {
            cssOverrides: {
                pagination: css`
                    background-color: #f0f4f3;
                    padding: 5px;
                    border-radius: 4px;
                `,
                currentButton: css`
                    cursor: default;
                    color: ${getProp("theme.colors.primary.contrast")};
                    background-color: ${getProp("theme.colors.primary.main")};
                    border-color: ${getProp("theme.colors.primary.main")};
                    min-height: 30px;
                `,
                linkList: css`
                    button {
                        max-width: 24px;
                    }
                `,
            },
        },
    },
    lists: {
        defaultProps: {
            css: css`
                margin: 0px;
                padding: 0px;
            `,
        },
    },
});
